export default class SendTemplateModalController {
    constructor($uibModalInstance, $scope, $injector, template) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.template = template;

        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.sce = this.injector.get('$sce');
        this.contactsBaseStore = this.injector.get('Contacts');
        this.rsvpsBaseStore = this.injector.get('Rsvps');

        this.message = {
            type: 'email',
            send_to_override: '',
            recipient_type: 'contact',
            templates: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [template.id]
                    }
                ],
                count: 1
            },
            attach_ticket: true,
            attach_passbook: true,
            attach_files: true,
            attach_invoice: true
        };

        this.contactsConfig = {
            store: this.contactsBaseStore.reset({persist: false}),
            maxItems: 1,
            displayField: 'full_name'
        };

        this.rsvpsConfig = {
            store: this.rsvpsBaseStore.create('TemplateRsvps').reset({persist: false}),
            maxItems: 1,
            displayField: 'contact.full_name'
        };

        this.recipientTypes = {
            type: 'select',
            options: {
                contact: 'Contact',
                rsvp: 'Booking'
            },
            required: true
        }

    }

    close() {
        this.modalInstance.dismiss();
    }

    send(form) {
        if (form.$valid && this.message.send_to_override) {
            if (this.message.recipient_type === 'contact') {
                delete this.message.rsvps;
                this.message.contacts = this.contactsConfig.store.getters.selectedFilters
            } else if (this.message.recipient_type === 'rsvp') {
                delete this.message.contacts;
                this.message.rsvps = this.rsvpsConfig.store.getters.selectedFilters
            }
            this.sending = true;
            return this.api.post(`messages`, this.message)
                .then(() => {
                    this.alert.success('Message Sent', 'Your message has been queued for sending');
                    this.close();
                }, response => {
                    this.alert.handle(response);
                })
                .finally(() => {
                    this.sending = false;
                });
        }
    }
}

SendTemplateModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'template'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/controllers/workflows/details/send-template-modal-controller.js